<template>
  <div class="topic">
    <div class="topic-left">
      <ul class="topic-list">
        <li class="topic-item">
          <router-link class="topic-item__link" to="/">
            <img class="topic-item__icon" :src="require('@/assets/images/car/icon_home.png')" />
            <div class="topic-item__name">首页</div>
          </router-link>
        </li>
        <li class="topic-item">
          <router-link class="topic-item__link" to="/list/used">
            <img class="topic-item__icon" :src="require('@/assets/images/car/icon_used.png')" />
            <div class="topic-item__name">二手车</div>
          </router-link>
        </li>
        <li class="topic-item">
          <router-link class="topic-item__link" to="/list/lease">
            <img class="topic-item__icon" :src="require('@/assets/images/car/icon_lease.png')" />
            <div class="topic-item__name">转 Lease</div>
          </router-link>
        </li>
        <li class="topic-item">
          <a class="topic-item__link" target="_blank" :href="`/list/dealer` | hostBuild('forum')">
            <img class="topic-item__icon" :src="require('@/assets/images/car/icon_shop.png')" />
            <div class="topic-item__name">车行专卖</div>
          </a>
        </li>
        <li class="topic-item">
          <a class="topic-item__link" target="_blank" :href="`/list/life` | hostBuild('news')">
            <img class="topic-item__icon" :src="require('@/assets/images/car/icon_news.png')" />
            <div class="topic-item__name">汽车资讯</div>
          </a>
        </li>
        <li class="topic-item">
          <a class="topic-item__link" target="_blank" :href="`/list/car` | hostBuild('forum')">
            <img class="topic-item__icon" :src="require('@/assets/images/car/icon_forum.png')" />
            <div class="topic-item__name">汽车论坛</div>
          </a>
        </li>
      </ul>
    </div>
    <div class="topic-right">
      <div class="topic-item">
        <a class="topic-item__link" target="_blank" :href="`/list/car` | hostBuild('info')">
          <img class="topic-item__icon" :src="require('@/assets/images/car/icon_shop.png')" />
          <div class="topic-item__name">汽车服务</div>
        </a>
      </div>
      <ul class="cate-list">
        <li class="cate-item active">
          <a class="cate-item__link" :href="`/list/coach` | hostBuild('info')">教车师傅</a>
        </li>
        <li class="cate-item active">
          <a class="cate-item__link" :href="`/list/autorepair` | hostBuild('info')">汽车维修</a>
        </li>
        <li class="cate-item">
          <a class="cate-item__link" :href="`/list/autoinsurance` | hostBuild('info')">汽车保险</a>
        </li>
        <li class="cate-item">
          <a class="cate-item__link" :href="`/list/ticket` | hostBuild('info')">交通告票</a>
        </li>
        <li class="cate-item">
          <a class="cate-item__link" :href="`/list/cartrade` | hostBuild('info')">购车服务</a>
        </li>
        <li class="cate-item">
          <a class="cate-item__link" :href="`/list/trailer` | hostBuild('info')">拖车服务</a>
        </li>
        <li class="cate-item">
          <a class="cate-item__link" :href="`/list/carrental` | hostBuild('info')">租车服务</a>
        </li>
        <li class="cate-item">
          <a class="cate-item__link" :href="`/list/tire` | hostBuild('info')">轮胎轮毂</a>
        </li>
        <li class="cate-item">
          <a class="cate-item__link" :href="`/list/autoaccessory` | hostBuild('info')">汽配美容</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Topic',
};
</script>
<style lang="scss" scoped>
.topic {
  margin-bottom: 20px;
  padding: 20px 35px;
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  display: flex;
}
.topic-left {
  flex: 1;
  display: flex;
  position: relative;
  &::after {
    position: absolute;
    content: '';
    width: 1px;
    height: 52px;
    background: #e2e2e2;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.topic-list {
  display: flex;
}
.topic-item {
  text-align: center;
  margin-right: 34px;
}
.topic-item__link {
  display: block;
  color: #191919;
  &:hover {
    color: var(--primary-color);
  }
}
.topic-item__icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-bottom: 8px;
}
.topic-item__name {
  font-size: 14px;
  line-height: 20px;
  color: inherit;
  text-align: center;
}
.topic-right {
  flex: 1;
  display: flex;
  align-items: center;
  padding-left: 50px;
}
.cate-list {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
}
.cate-item {
  font-size: 15px;
  line-height: 21px;
  color: var(--text-color-3);
  width: 80px;
  margin-right: 5px;
  &.active {
    color: var(--primary-color);
  }
  &:hover {
    color: var(--primary-color);
  }
  &:nth-child(-n + 5) {
    margin-bottom: 15px;
  }
}
</style>
